import axios from "axios";

import { persistor } from '../services/store/store';
import { authToken, clearAuthToken } from '../storage/authToken';
import * as Breadcrumbs from '../monitoring/breadcrumbs';

/**
 * Record "POST /api/thing -> 500" on the error trail. Endpoint + status only —
 * request/response bodies are never touched. Best-effort; never throws.
 */
function recordApiBreadcrumb(config, status) {
	try {
		if (!config) {
			return;
		}
		const method = String(config.method || 'get').toUpperCase();
		Breadcrumbs.api(`${method} ${config.url || ''} -> ${status}`);
	} catch (_) {
		/* never break a request */
	}
}

const Axios = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL
});

Axios.interceptors.request.use(
	(config) => {
		const token = authToken();

		config.headers["Accept"] = "application/json";
		// config.headers["Content-Type"] = "application/json";

		if (token) {
			config.headers["Authorization"] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

Axios.interceptors.response.use(
	(response) => {
		recordApiBreadcrumb(response?.config, response?.status);
		return response
	},
	(error) => {
		recordApiBreadcrumb(error?.config, error?.response?.status || 'network-error');
		if (error?.response?.status === 401) {
			clearAuthToken()
			persistor.purge()
			window.location.href = '/'
		}
		return Promise.reject(error);
	}
);

export default Axios;
